import { HTTPV } from '../utils/http-common';

export const api_services = () => HTTPV(JSON.parse(localStorage.getItem('env')).BACK_API_SERVICES);
